module.exports = __webpack_public_path__ + "static/media/image-3.201be146.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/UX/image-3.png
// module id = 450
// module chunks = 0